import { createAsyncThunk } from "@reduxjs/toolkit";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import { axios } from "../../common";
import OptionHeaders from "../options";
const { token, baseUrl } = OptionHeaders();
const EMPLOYEE_SHOW = "employee/show";
const EMPLOYEE_SHOW_OID = "employee/show_oid";
const EMPLOYEES_SHOW_BY_DECLARANT = "employee/show_by_declarant";

export const showEmployee = createAsyncThunk(
  EMPLOYEE_SHOW,
  async (thunkAPI) => {
    try {
      const employee = new DataSource({
        store: new ODataStore({
          url: `${baseUrl}Employee`,
          key: "Oid",
          version: 4,
          beforeSend: (request) => {
            request.headers["token"] = token;
            request.headers["MappedState"] = 1;
          },
        }),
        expand: ["Department", "Position"],
        filter: ["DateOut", "=", null],
      });
      return employee;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const showEmployeeByOid = createAsyncThunk(
  EMPLOYEE_SHOW_OID,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.get(`Employee(${payload})`, {
        params: {
          $expand: "Department,Position,ForeignLevel",
        },
        headers: {
          MappedState: 1,
        },
      });
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
export const getEmployeeByDeclarant = createAsyncThunk(
  EMPLOYEES_SHOW_BY_DECLARANT,
  async (payload, thunkAPI) => {
    try {
      const { data } = await axios.get(
        `Employee/GetEmployeeByDeclarant(${payload})`,
        {
          headers: {
            MappedState: 1,
          },
        }
      );
      return data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response.data);
    }
  }
);
